import moment from 'moment'

// 分割払い
export const splitPay = (total, count, addon) => {
  // //手数料
  let fee = Math.floor((total * (addon * 100) * count) / 100 / 100)

  let floorValue = 10

  // if(count >= 24 && total <= 100000){
  //     floorValue = 10
  // }else{
  //     floorValue = 100
  // }

  // const paymentPeriodStart = start;
  // const paymentPeriodEnd = paymentPeriodStart.clone().add(count,'M');

  // 総合計金額
  const payTotal = total + fee

  const paymentAmountSecond = Math.floor(payTotal / count / floorValue) * floorValue

  // 二回目以降の支払い金額
  // const paymentAmountSecond = Math.floor(payTotal / count )

  // 一回目の支払い金額を求める計算
  const secondPayCount = count - 1
  const secondPaySum = paymentAmountSecond * secondPayCount
  const paymentAmountOnce = payTotal - secondPaySum

  return {
    paymentAmountOnce: paymentAmountOnce,
    paymentAmountSecond: paymentAmountSecond,
    fee: fee,
    total: payTotal
    // paymentPeriodStart: paymentPeriodStart,
    // paymentPeriodEnd: paymentPeriodEnd,
  }
}

// 分割・ボーナス併用
export const splitBonusPay = (total, count, addition_amount, month1, month2, payment_period_start, addon) => {
  // //手数料
  let fee = Math.floor((total * (addon * 100) * count) / 100 / 100)

  const payTotal = total + fee

  let floorValue = 10

  // if(count >= 24 && total <= 100000){
  //     floorValue = 10
  // }else{
  //     floorValue = 100
  // }

  // 分割回数の回数分指定したボーナス月がどれだけあるか調べる処理
  let bonusCombinedNumber = 0
  for (let i = 0; i < count; i++) {
    const add_month = moment(payment_period_start).add(i, 'M').startOf('day').format('M')
    // console.log(add_month,month);
    // console.log(add_month == month);
    if (add_month == month1 || add_month == month2) {
      bonusCombinedNumber++
    }
  }

  const bonusPay = bonusCombinedNumber * addition_amount

  const paymentAmountSecond = Math.floor((payTotal - bonusPay) / count / floorValue) * floorValue

  // 二回目以降の支払い金額
  // const paymentAmountSecond = Math.floor((payTotal - bonusPay) / count);

  // 一回目の支払い金額を求める計算
  const secondPayCount = count - 1
  const secondPaySum = paymentAmountSecond * secondPayCount
  const paymentAmountOnce = payTotal - bonusPay - secondPaySum

  return {
    paymentAmountOnce: paymentAmountOnce,
    paymentAmountSecond: paymentAmountSecond,
    fee: fee,
    total: payTotal,
    bonusCombinedNumber: bonusCombinedNumber
  }
}

export const oncePay = (total, addon, payer) => {
  //手数料
  let fee = Math.floor((total * addon * 100) / 100 / 100)

  if (payer) {
    fee = 0
  }

  return {
    paymentAmountOnce: total + fee,
    total: total + fee,
    fee
  }
}

// ボ2
export const secondsPay = (total, addon, payer) => {
  //手数料
  let fee = Math.floor((total * addon * 100) / 100 / 100)

  let floorValue = 1

  if (payer) {
    fee = 0
  }

  const payTotal = total + fee

  const paymentAmountSecond = Math.floor(payTotal / 2 / floorValue) * floorValue
  const paymentAmountOnce = payTotal - paymentAmountSecond

  return {
    paymentAmountOnce: paymentAmountOnce,
    paymentAmountSecond: paymentAmountSecond,
    total: payTotal,
    fee
  }
}

// マンスリークリア
export const monthlyPay = (total, addon, payer) => {
  // const diff = first.date(2).diff(start.date(1),'M')
  // let fee = Math.floor(total * addon * diff / 100)
  // let fee = 0;

  // let floorValue = 1

  // if(payer){
  //     fee = 0
  // }

  // let fee = total * addon;
  let fee = 0

  // const paymentPeriodEnd = getbonusMonth(start, appDate, appDateUse, once);
  // const paymentPeriodStart = appDateUse ? paymentPeriodEnd : start;

  return {
    paymentAmountOnce: total + fee,
    total: total + fee,
    fee: fee
    // paymentPeriodStart: paymentPeriodStart,
    // paymentPeriodEnd: paymentPeriodEnd,
  }
}
